/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Checkbox, PasswordInput, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import React, { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Halment from "../../faetures/Halment";
import logo from "../../images/logo1.png";
import { userLogin } from "../../redux/actions/frontendActions/authenticationAction";
function Login({history}) {
    
  const {  successMessage,  authenticate,loading ,loginError } = useSelector(state => state.Auth);
  const dispatch = useDispatch();
  const form = useForm({
    initialValues: {
      email: "",
      password: "",
    },

    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      password: (value) =>
        value.length < 6 ? "Password Must be 6 caracter" : null,
    },
  });

  const handleFormSubmit =(e) => {
   dispatch(userLogin(form.values)) 
   }


   useEffect(() => {
    if (authenticate) {
        history.push('/')
    }
    if (successMessage) {
        toast.success(successMessage);
        dispatch({ type: "SUCCESS_MESSAGE_CLEAR" })
    }
    if (loginError) {
        toast.error(loginError)
        dispatch({ type: "ERROR_CLEAR" })
    }
}, [successMessage, loginError])


  return (
    <div className="authentication_wrapper">
       <Halment title="Login Account" />
              <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            style: {
              fontSize: "14px",
            },
          }}
        />
      <div className="logo_area">
        <Link to="/">
          <img src={logo} alt="" />
        </Link>
      </div>

      <div className="authentication-area">
        <div className="authentication_form_area">
          <div className="form_top">
            <div className="text">Login</div>
            <div className="render">
              <Link to="/register">New Here? Create account</Link>
            </div>
          </div>
          <form onSubmit={form.onSubmit(handleFormSubmit)}>
            <div className="form_item">
              <TextInput
                className="auth_form_controll"
                withAsterisk
                label="Email Address"
                placeholder="your@email.com"
                {...form.getInputProps("email")}
              />
            </div>
            <div className="form_item">
              <PasswordInput
                className="auth_form_controll"
                placeholder="Password"
                label="Password"
                // description="Password must include at least one letter, number and special character"
                withAsterisk
                {...form.getInputProps("password")}
              />
            </div>
            <div className="form_item">
              <Checkbox label="Remember Me" />
            </div>

            <div className="form_item">
              <div className="submit_button">
                <Button type="submit" variant="filled">
                  {
                    loading ? "Please Wait...": "Log In"
                  }
                 
                 
                </Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
